import React from 'react';
import { AlertTriangle, Loader2 } from 'lucide-react';
import Modal from './Modal';

/**
 * Dialog de confirmação para ações destrutivas
 * Props: aberto, onFechar, onConfirmar, titulo, mensagem, loading, textoBotao
 */
export default function ConfirmDialog({
  aberto, onFechar, onConfirmar,
  titulo = 'Confirmar ação',
  mensagem = 'Tem certeza que deseja continuar?',
  loading = false,
  textoBotao = 'Confirmar',
  tipo = 'danger'  // 'danger' | 'warning'
}) {
  return (
    <Modal aberto={aberto} onFechar={onFechar} titulo={titulo} tamanho="sm">
      <div className="space-y-4">
        <div className="flex gap-3">
          <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${
            tipo === 'danger' ? 'bg-red-900/40' : 'bg-amber-900/40'
          }`}>
            <AlertTriangle size={18} className={tipo === 'danger' ? 'text-red-400' : 'text-amber-400'} />
          </div>
          <p className="text-sm text-slate-300 leading-relaxed">{mensagem}</p>
        </div>

        <div className="flex gap-2 justify-end pt-2">
          <button onClick={onFechar} disabled={loading} className="btn-secondary text-sm py-1.5 px-4">
            Cancelar
          </button>
          <button
            onClick={onConfirmar}
            disabled={loading}
            className={`text-white font-medium px-4 py-1.5 rounded-lg transition-colors flex items-center gap-2 text-sm disabled:opacity-50 ${
              tipo === 'danger'
                ? 'bg-red-600 hover:bg-red-700'
                : 'bg-amber-600 hover:bg-amber-700'
            }`}
          >
            {loading && <Loader2 size={14} className="animate-spin" />}
            {textoBotao}
          </button>
        </div>
      </div>
    </Modal>
  );
}
